export const Token = 'example'
export const TokenTwo = 'example_two'
export const TokenThree = 'example_three'
export const TokenFour = 'example_four'
